import React, { useEffect, useState } from 'react'
import List from '../../../Component/DatabaseSearch/List'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { databaseSearch } from '../../../action/databaseSearch';
import Loader from '../../../Component/Common/Loader';
import constant from '../../../constant';
import Filter from '../../../Component/DatabaseSearch/List/Filter'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronDown, faLocationDot, faPencil } from '@fortawesome/free-solid-svg-icons';
const Index = () => {
    const [showDetail, setShowDetail] = useState(false)
    const location = useLocation();
    const searchModel = location.state || null; // Get search data
    console.log(searchModel)
    const [showLoader, setShowLoader] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [data, setData] = useState(null)
    const history = useHistory()



    useEffect(() => {
        if (!searchModel) {
            history.push(constant.component.databaseSearch.url);
        }
        else {

            setShowLoader(true)

            databaseSearch({ ...searchModel, page: currentPage, limit }).then((res) => {
                if (res.status) {
                    setData(res.result)
                }
                else {
                    toast.error(res.error)
                }
            }).finally(() => {
                setShowLoader(false)
            })
        }

    }, [])
    return (
        <React.Fragment>
            {showLoader && <Loader />}
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className={`${styles['text-comm']}`}><FontAwesomeIcon icon={faArrowLeft} className='pe-1' />3584 profiles found for <strong>Software Developer, Fullstack</strong><a className={`${styles['text-link']} ps-2`} href='javascript:void(0);'
                                onClick={() => {
                                    setShowDetail(!showDetail)
                                }}>{showDetail ? 'Hide details' : 'View details'}<FontAwesomeIcon className='ps-2' icon={faChevronDown} /></a></h6>
                            <div className={`${styles['text-comm']} border-start border-end px-3 text-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faLocationDot} />Bangalore (Bengalu...)
                            </div>
                            <div className={`${styles['text-comm']} border-end text-center px-3`}>
                                Previous:<strong>Premium</strong>
                            </div>
                            <div>
                                <a href='#' className={`${styles['edit-btn']} btn`}><FontAwesomeIcon icon={faPencil} className='pe-1' />Edit</a>
                            </div>
                        </div>
                        {showDetail && <div>

                            <h5 className={`${styles['ct-title']}`}>Showing Result for</h5>

                            {/* Keywords Section */}
                            <div className="my-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Keywords</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {
                                        searchModel.keyword.map((item) => {
                                            return (
                                                <span className={`${styles['ct-badge']}`}>
                                                    {item} <span className="ms-1">&times;</span>
                                                </span>
                                            )
                                        })

                                    }
                                </div>
                            </div>
                            <div className="my-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>City</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {
                                        searchModel.location.map((item) => {
                                            return (
                                                <span className={`${styles['ct-badge']}`}>
                                                    {item} <span className="ms-1">&times;</span>
                                                </span>
                                            )
                                        })

                                    }
                                </div>
                            </div>
                            {/* Experience Section */}
                            <div className="mb-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Experience</h6>
                                <span className={`${styles['ct-badge']}`}>
                                    2 Years <span className="ms-1">&times;</span>
                                </span>
                            </div>

                            {/* Applied Filters */}
                            <div className="mb-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Applied Filters</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {["Legal & Regulatory", "Outsourcing BPO/BPM"].map((filter, index) => (
                                        <span key={index} className={`${styles['ct-badge']}`}>
                                            {filter} <span className="ms-1">&times;</span>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        }
                        <div className="row">
                            <Filter />
                            {<List
                                data={data}
                            />}
                        </div>
                    </div>
                </div>
            </div >
        </React.Fragment>
    )
}

export default Index